import type { AxiosInstance } from "axios";

import { createAxiosClient } from "../../oidc-client-auth/axiosClient";
import { getOidcUserManager } from "../../oidc-client-auth/userManagerSingleton";
import { handle401Error } from "../../oidc-client-auth/handle401Error";

const cache = new Map<string, AxiosInstance>();

function keyFor(baseURL?: string): string {
  return baseURL && baseURL.trim() ? baseURL.trim() : "__default__";
}

export function getAuthedAxios(baseURL?: string): AxiosInstance {
  const key = keyFor(baseURL);
  const existing = cache.get(key);
  if (existing) return existing;

  // During SSR there is no `window`, so the OIDC UserManager cannot exist.
  // We still return an axios instance so modules can be imported safely.
  const userManager = typeof window !== "undefined" ? getOidcUserManager() : null;

  const client = createAxiosClient({
    userManager,
    baseURL,
    onAuthFailure: () => {
      try {
        const currentPath =
          typeof window !== "undefined"
            ? `${window.location.pathname}${window.location.search}`
            : "/";
        handle401Error(currentPath);
      } catch {
        // If we're not in a browser-like environment, just no-op.
      }
    },
  });

  cache.set(key, client);
  return client;
}

